import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"
import FeatherIcon from "feather-icons-react"

// Import from constants
import { SERVICE_CONFIG, SERVICE_KEYS } from "../../../constants"

const ServicesSection = () => {
    const { t } = useTranslation()

    return (
        <section className="section" id="services">
            <Container>
                {/* Section Title */}
                <Row className="justify-content-center">
                    <Col xs={12} className="text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">{t("services.title")}</h4>
                            <p className="text-muted para-desc mx-auto mb-0">
                                {t("services.subtitle")}
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* Services Grid */}
                <Row>
                    {SERVICE_KEYS.map((key, idx) => {
                        const config = SERVICE_CONFIG[key]
                        return (
                            <Col lg={4} md={6} className="mt-4 pt-2" key={idx}>
                                <Card className="features feature-primary feature-clean explore-feature border-0 shadow rounded h-100">
                                    <CardBody className="p-4 text-center">
                                        <div
                                            className="icons rounded-circle shadow-lg d-inline-flex align-items-center justify-content-center mb-3"
                                            style={{
                                                width: '60px',
                                                height: '60px',
                                                backgroundColor: `${config.color}15`
                                            }}
                                        >
                                            <FeatherIcon
                                                icon={config.icon}
                                                className="fea"
                                                style={{ width: "28px", height: "28px", color: config.color }}
                                            />
                                        </div>
                                        <h5>
                                            <Link to={config.path} className="title text-dark">
                                                {t(`services.${key}.title`)}
                                            </Link>
                                        </h5>
                                        <p className="text-muted mb-3">
                                            {t(`services.${key}.description`)}
                                        </p>
                                        <Link to={config.path} className="text-primary">
                                            {t("common.details", "Detaylar")}
                                            <FeatherIcon icon="arrow-right" className="fea icon-sm ms-1" />
                                        </Link>
                                    </CardBody>
                                </Card>
                            </Col>
                        )
                    })}
                </Row>
            </Container>
        </section>
    )
}

export default ServicesSection
